export const AUTH_STORAGE_KEY = "alphasniper_auth";

export function readAdminSession() {
  try {
    const raw = sessionStorage.getItem(AUTH_STORAGE_KEY);
    if (!raw) return null;
    const s = JSON.parse(raw);
    if (s?.isAdmin === true && s?.clientId != null) return s;
  } catch {
    /* ignore */
  }
  return null;
}

export function saveAdminSession(payload) {
  sessionStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(payload));
}

export function clearAdminSession() {
  sessionStorage.removeItem(AUTH_STORAGE_KEY);
}
